import { Component, Injectable } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ThemeService } from "./services/theme.service";

@Component({
  selector: "vex-root",
  templateUrl: "./app.component.html",
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent {

  constructor(private themeService: ThemeService) {
    this.themeService.setSystemTheme();
  }

}